module.exports = __webpack_public_path__ + "b24a36689673b4a23803d1bcc2016fa9.pdf";